import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=a05f9ed4&scoped=true"
import script from "./DeleteAccount.vue?vue&type=script&lang=ts"
export * from "./DeleteAccount.vue?vue&type=script&lang=ts"
import style0 from "./DeleteAccount.vue?vue&type=style&index=0&id=a05f9ed4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05f9ed4",
  null
  
)

export default component.exports